import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface ModalData {
  title: string;
  message: string;
  buttons: {
    text: string;
    value: string;
    cssClass?: string;
    type?: 'flat' | 'raised'
  }[];
}
@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.css']
})
export class PopupModalComponent {
  constructor(
    public dialogRef: MatDialogRef<PopupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData
  ) { }

  close(result: string): void {
    this.dialogRef.close(result);
  }
}
